import React, { useState, useEffect } from "react";

const TableOfContent = ({ toc, add_class }) => {
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    // Create an IntersectionObserver
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // If the section is in view, update the active section
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        rootMargin: "0px",
        threshold: 0.5, // Trigger when 50% of the section is in view
      }
    );

    // Observe each section with an ID that corresponds to a TOC item
    toc.items.forEach((item) => {
      const section = document.getElementById(item.url.slice(1)); // Remove the '#' from the URL
      if (section) {
        observer.observe(section);
      } 
    });

    // Cleanup the observer on component unmount
    return () => {
      observer.disconnect();
    };
  }, [toc.items]);

  return (
    <div className={`${add_class} w-full max-w-[360px] p-thin rounded-[8px] mt-normal bg-[#e5f4e3]`}>
  <h2 className="text-[20px] font-bold mb-thin">Table Of Contents</h2>
  <ol className="text-[16px]">
    {toc.items.map((item, index) => (
      <li
        key={index}
        className={`mb-2  hover:text-[#181A2A] transition-colors duration-200 ${
          activeSection === item.url.slice(1) ? "text-[#181A2A] font-bold" : "text-[#646568]"
        }`}
      >
        <a href={item.url}>{item.title}</a>
      </li>
    ))}
  </ol>
</div>

  );
};

export default TableOfContent;
